export const cn = {
    creditsPricing: {
        title: '选择最适合您的方案',
        subtitle: '解锁专业功能，提升您的工作效率',
        headerTexts: {
            pricing_proactive_view: { title: '选择适合你的方案', subtitle: '升级套餐或增加 Credits，解锁更多能力。' },
            feature_upgrade_required: { title: '升级后即可使用此功能', subtitle: '此功能不包含在当前方案中，请升级后继续。' },
            credits_limit_upgrade: { title: 'Credits 已用完', subtitle: '增加 Credits 或升级套餐后即可继续使用。' },
        },
        free: '免费',
        currentPlan: '当前方案',
        recommend: '推荐',
        monthly: '月付',
        yearly: '年付',
        month: '月',
        perMonth: '/月',
        save: '省 $ {amount}',
        upgrade: '升级',
        downgrade: '降级',
        contactSales: '联系销售',
        bookDemo: '预约演示',
        custom: '定制化',
        learnMore: '了解更多',
        creditsPerMonth: '{credits} 积分 / 月',
        creditsPerMonthSuffix: '积分 / 月',
        scheduledDowngrade: '预约降级',
        scheduledDowngradeNotice: '预约 {date} 降级到 {tier}',
        fiveXCreditsNotice: {
            title: '早鸟优惠已为您激活。',
            description: '每个套餐包含标准积分的 {multiplier} 倍，续费时将保持相同费率。如有变更，我们将在下一个计费周期前 7 天通知您。',
        },
        freeCreditsRefresh: '免费积分每月刷新',
        creditsIncluded: '专业版方案包含的积分',
        everythingInBasic: '包含基础版所有功能，额外：',
        everythingInPro: '包含专业版所有功能，额外：',
        everythingInProPlus: '包含专业版所有功能：',
        securityControl: '安全与管理',
        enterpriseCategories: {
            teamUsage: '团队使用与管理',
            collaboration: '协作',
            governanceSecurity: '治理与安全',
            serviceSuccess: '服务与成功',
        },
        basic: '基础版',
        pro: '专业版',
        enterprise: '企业版',
        api: 'API',
        basicDesc: '适合个人用户和开发者',
        proDesc: '适合高级用户和开发者',
        enterpriseDesc: '适合高效能团队',
        apiDesc: '适合自定义基础设施',
        features: {
            basic1: '访问精选核心智能体',
            basic2: '内置技能和连接器，提供现成的研发工作流和精选数据工具',
            basic3: 'AI 驱动的 Pulse 简报，追踪竞争情报',
            pro1: '更深度的智能体工作流，用于研究、验证和监控',
            pro2: '专业导出，附带支撑证据（专利和文献）',
            pro3: '更多可追踪的技术主题和竞争信号',
            // Enterprise - Team usage & administration
            enterpriseTeam1: '完全访问所有 Eureka 智能体',
            enterpriseTeam2: '团队共享积分池与自定义分配',
            enterpriseTeam3: '账单、使用量和用户管理控制台',
            // Enterprise - Collaboration
            enterpriseCollab1: '共享工作区和团队项目',
            enterpriseCollab2: '团队范围的情报分发',
            // Enterprise - Governance & Security
            enterpriseSecurity1: 'SSO 和企业安全控制',
            enterpriseSecurity2: '用户和工作区的基于角色权限',
            enterpriseSecurity3: '文件上传控制',
            enterpriseSecurity4: '隐私无痕模式',
            // Enterprise - Service & Success
            enterpriseService1: '专属客户支持',
            enterpriseService2: '99.9% SLA 和主动监控',
            enterprise1: '个人成员配额管理',
            enterprise2: '无限团队共享知识库',
            security1: '内部情报共享',
            security2: '隐私无痕模式',
            security3: '统一团队权限管理',
            security4: '专属客户支持',
            api1: '300+ 数据 API 和 60+ AI 智能体 API，覆盖专利、生命科学、研发和市场情报',
            api2: '将图表、洞察和 AI 工作流嵌入您的产品，无需重建',
            api3: '通过任何 MCP 兼容客户端连接可信的 PatSnap 工具，包括 Claude Desktop 和 Cursor',
            api4: '使用 LangChain、OpenClaw、CrewAI 等框架构建和编排工作流',
            api5: '在一处探索场景演示、测试 API、构建组件和生成代码',
        },
        // 升级确认弹窗
        upgradeConfirm: {
            title: '升级',
            titleWithTier: '升级到 {tier}',
            subtitle: '升级立即生效。',
            currentPlan: '当前方案',
            targetPlan: '目标方案',
            dueToday: '今日应付',
            creditsGrantedToday: '今日获得积分',
            creditsValidUntil: '积分有效期至',
            nextRenewal: '下次续费',
            creditsRetainedNotice: '您现有的积分将被保留，可与新积分一起使用。',
            loadFailed: '加载升级详情失败。',
            retry: '重试',
            cancel: '取消',
            processing: '处理中...',
            upgradeNow: '立即升级',
            credits: '+{amount} 积分',
            upgradeSuccess: '感谢订阅！ 你的早鸟奖励已到账：5 倍积分已发放至你的账户，快去查看吧。',
        },
        // 降级确认弹窗
        downgradeConfirm: {
            title: '预约降级',
            titleWithTier: '预约降级到 {tier}',
            subtitle: '您的 {tier} 套餐将保持有效至 {date}。',
            currentPlan: '当前方案',
            scheduledPlan: '当前降级方案',
            newDowngradePlan: '新降级方案',
            effectiveDate: '生效日期',
            currentCredits: '当前积分',
            creditsKept: '保留至原到期日',
            creditsExpire: '将在周期结束时过期',
            creditsNextCycle: '下周期积分',
            nextRenewal: '下次续费',
            renewalAmount: '{date} 续费 {currency} {amount}',
            cancelNotice: '您可以在 {date} 之前取消此预约降级。',
            loadFailed: '加载降级详情失败。',
            retry: '重试',
            keepCurrentPlan: '保持当前方案',
            keepTier: '保持 {tier}',
            processing: '处理中...',
            scheduleDowngrade: '预约降级',
            credits: '{amount} 积分',
            successMessage: '降级已预约成功！您的 {tier} 套餐将保持有效至 {date}。',
        },
        oldProTip: {
            title: '暂无法更新订阅',
            description: '你当前仍在旧版 Pro 订阅周期内。旧版计次套餐和 Credits 积分套餐不能同时生效。如需切换到 Credits 积分套餐，请先取消续订；当前订阅结束后，你可以重新订阅新套餐。',
            confirm: '查看订阅',
            cancel: '我知道了',
        },
    },
};

export const en = {
    creditsPricing: {
        title: 'Choose the Right Plan for You',
        subtitle: 'Unlock professional features and boost your productivity',
        headerTexts: {
            pricing_proactive_view: { title: 'Choose the right plan for you', subtitle: 'Upgrade your plan or add credits to unlock more.' },
            feature_upgrade_required: { title: 'Upgrade to use this feature', subtitle: 'This feature is not included in your current plan.' },
            credits_limit_upgrade: { title: 'You\'re out of Credits', subtitle: 'Add credits or upgrade your plan to continue.' },
        },
        free: 'Free',
        currentPlan: 'Current Plan',
        recommend: 'Recommend',
        monthly: 'Monthly',
        yearly: 'Yearly',
        month: 'month',
        perMonth: '/month',
        save: 'Save $',
        upgrade: 'Upgrade',
        downgrade: 'Downgrade',
        contactSales: 'Contact Sales',
        bookDemo: 'Book a Demo',
        custom: 'Custom',
        learnMore: 'Learn More',
        creditsPerMonth: '{credits} credits / month',
        creditsPerMonthSuffix: 'credits / month',
        scheduledDowngrade: 'Scheduled Downgrade',
        scheduledDowngradeNotice: 'Scheduled to downgrade to {tier} on {date}',
        fiveXCreditsNotice: {
            title: 'Early access pricing is active for you.',
            description: 'Every plan includes {multiplier} the standard credits, and your renewal will honor the same rate. If this ever changes, we\'ll notify you 7 days before your next billing cycle.',
        },
        freeCreditsRefresh: 'Free credits refresh monthly',
        creditsIncluded: 'Credits included in your Pro plan',
        everythingInBasic: 'Everything in basic, plus',
        everythingInPro: 'Everything in pro, plus',
        everythingInProPlus: 'Everything in Pro, plus:',
        securityControl: 'Security & Control',
        enterpriseCategories: {
            teamUsage: 'Team usage & administration',
            collaboration: 'Collaboration',
            governanceSecurity: 'Governance & Security',
            serviceSuccess: 'Service & Success',
        },
        basic: 'Basic',
        pro: 'Pro',
        enterprise: 'Enterprise',
        api: 'API',
        basicDesc: 'For power users & developers',
        proDesc: 'For power users & developers',
        enterpriseDesc: 'For high-performing teams',
        apiDesc: 'For custom infrastructure',
        features: {
            basic1: 'Access to selected core agents',
            basic2: 'Built-in skills and connectors with ready-made R&D workflows and curated data tools',
            basic3: 'AI-enabled Pulse briefs tracking competitive intelligence',
            pro1: 'Deeper agent workflows for research, validation, and monitoring',
            pro2: 'Professional exports with supporting evidence (patents & literature) ',
            pro3: 'More tracked technical topics and competitive signals',
            // Enterprise - Team usage & administration
            enterpriseTeam1: 'Full access to all Eureka agents',
            enterpriseTeam2: 'Team-pooled credits with custom allocation',
            enterpriseTeam3: 'Admin console for billing, usage, and user management',
            // Enterprise - Collaboration
            enterpriseCollab1: 'Shared workspaces and team projects',
            enterpriseCollab2: 'Team-wide intelligence distribution',
            // Enterprise - Governance & Security
            enterpriseSecurity1: 'SSO and enterprise security controls',
            enterpriseSecurity2: 'Role-based permissions for users and workspaces',
            enterpriseSecurity3: 'File upload controls',
            enterpriseSecurity4: 'Private incognito mode',
            // Enterprise - Service & Success
            enterpriseService1: 'Dedicated customer support',
            enterpriseService2: '99.9% SLA and proactive monitoring',
            enterprise1: 'Individual member quota management',
            enterprise2: 'Unlimited Shared Vaults for Teams',
            security1: 'Internal intelligence sharing',
            security2: 'Private incognito mode',
            security3: 'Unified team permission management',
            security4: 'Dedicated customer support',
            api1: '300+ data APIs and 60+ AI agent APIs across patents, life sciences, R&D, and market intelligence',
            api2: 'Embed charts, insights, and AI workflows into your product — no rebuild required',
            api3: 'Connect trusted PatSnap tools through any MCP-compatible client, including Claude Desktop and Cursor',
            api4: 'Build and orchestrate workflows with LangChain, OpenClaw, CrewAI, and other frameworks',
            api5: 'Explore scenario demos, test APIs, build widgets, and generate code in one place',
        },
        // Upgrade confirm dialog
        upgradeConfirm: {
            title: 'Upgrade',
            titleWithTier: 'Upgrade to {tier}',
            subtitle: 'Your upgrade starts immediately.',
            currentPlan: 'Current plan',
            targetPlan: 'Target plan',
            dueToday: 'Due today',
            creditsGrantedToday: 'Credits granted today',
            creditsValidUntil: 'Credits valid until',
            nextRenewal: 'Next renewal',
            creditsRetainedNotice: 'Your existing credits will be retained and can be used alongside your new credits.',
            loadFailed: 'Failed to load upgrade details.',
            retry: 'Retry',
            cancel: 'Cancel',
            processing: 'Processing...',
            upgradeNow: 'Upgrade now',
            credits: '+{amount} credits',
            upgradeSuccess: 'Thanks for subscribing！ Your early bird bonus has arrived: 5× credits have been added to your account. Go check them out.',
        },
        // Downgrade confirm dialog
        downgradeConfirm: {
            title: 'Schedule downgrade',
            titleWithTier: 'Schedule downgrade to {tier}',
            subtitle: 'Your {tier} tier stays active until {date}.',
            currentPlan: 'Current plan',
            scheduledPlan: 'Current scheduled plan',
            newDowngradePlan: 'New scheduled plan',
            effectiveDate: 'Effective date',
            currentCredits: 'Current credits',
            creditsKept: 'Kept until their original expiration dates',
            creditsExpire: 'Will expire at period end',
            creditsNextCycle: 'Credits next cycle',
            nextRenewal: 'Next renewal',
            renewalAmount: 'US$ {amount} on {date}',
            cancelNotice: 'You can cancel this scheduled downgrade before {date}.',
            loadFailed: 'Failed to load downgrade details.',
            retry: 'Retry',
            keepCurrentPlan: 'Keep current plan',
            keepTier: 'Keep {tier}',
            processing: 'Processing...',
            scheduleDowngrade: 'Schedule downgrade',
            credits: '{amount} credits',
            successMessage: 'Downgrade scheduled successfully! Your {tier} plan will remain active until {date}.',
        },
        oldProTip: {
            title: 'Subscription update unavailable',
            description: 'You’re currently on an active legacy Pro subscription. Legacy count-based plans and Credits plans can’t be active at the same time. To switch to a Credits plan, please cancel renewal first. After your current subscription ends, you can subscribe to a new plan.',
            confirm: 'View subscription',
            cancel: 'Got it',
        },
    },
};

export const jp = {
    creditsPricing: {
        title: 'あなたに合ったプランを選択しましょう',
        subtitle: 'プロフェッショナル機能を解放し、生産性を向上させましょう',
        headerTexts: {
            pricing_proactive_view: { title: '自分に合ったプランを選択', subtitle: 'アップグレードまたは Credits の追加で、より多くの機能を利用できます。' },
            feature_upgrade_required: { title: 'アップグレード後に利用できます', subtitle: 'この機能は現在のプランには含まれていません。' },
            credits_limit_upgrade: { title: 'Credits を使い切りました', subtitle: 'Credits を追加するか、プランをアップグレードすると続けられます。' },
        },
        free: '無料',
        currentPlan: '現在のプラン',
        recommend: 'おすすめ',
        monthly: '月払い',
        yearly: '年払い',
        month: '月',
        perMonth: '/月',
        save: '$ お得',
        upgrade: 'アップグレード',
        downgrade: 'ダウングレード',
        contactSales: '営業に問い合わせ',
        bookDemo: 'デモを予約',
        custom: 'カスタム',
        learnMore: '詳しく見る',
        creditsPerMonth: '{credits} クレジット / 月',
        creditsPerMonthSuffix: 'クレジット / 月',
        scheduledDowngrade: '予約降級',
        scheduledDowngradeNotice: '{date} に {tier} への降級を予約済み',
        fiveXCreditsNotice: {
            title: '早期アクセス価格が適用されています。',
            description: 'すべてのプランに標準クレジットの {multiplier} 倍が含まれ、更新時も同じ料金が適用されます。変更がある場合は、次の請求サイクルの 7 日前にお知らせします。',
        },
        freeCreditsRefresh: '無料クレジットは毎月リフレッシュ',
        creditsIncluded: 'プロプランに含まれるクレジット',
        everythingInBasic: 'ベーシックの全機能に加え：',
        everythingInPro: 'プロの全機能に加え：',
        everythingInProPlus: 'プロの全機能に加え：',
        securityControl: 'セキュリティと管理',
        enterpriseCategories: {
            teamUsage: 'チーム利用と管理',
            collaboration: 'コラボレーション',
            governanceSecurity: 'ガバナンスとセキュリティ',
            serviceSuccess: 'サービスとサクセス',
        },
        basic: 'ベーシック',
        pro: 'プロ',
        enterprise: 'エンタープライズ',
        api: 'API',
        basicDesc: 'パワーユーザーと開発者向け',
        proDesc: 'パワーユーザーと開発者向け',
        enterpriseDesc: '高パフォーマンスチーム向け',
        apiDesc: 'カスタムインフラ向け',
        features: {
            basic1: '厳選されたコアエージェントへのアクセス',
            basic2: '組み込みスキルとコネクター、すぐに使える R&D ワークフローと厳選データツール',
            basic3: 'AI 搭載の Pulse ブリーフで競争インテリジェンスを追跡',
            pro1: 'リサーチ、検証、モニタリング向けのより深いエージェントワークフロー',
            pro2: '裏付け証拠（特許・文献）付きのプロフェッショナルエクスポート',
            pro3: 'より多くの技術トピックと競争シグナルを追跡',
            // Enterprise - Team usage & administration
            enterpriseTeam1: 'すべての Eureka エージェントへのフルアクセス',
            enterpriseTeam2: 'カスタム割り当て付きチーム共有クレジット',
            enterpriseTeam3: '請求、使用量、ユーザー管理の管理コンソール',
            // Enterprise - Collaboration
            enterpriseCollab1: '共有ワークスペースとチームプロジェクト',
            enterpriseCollab2: 'チーム全体のインテリジェンス配信',
            // Enterprise - Governance & Security
            enterpriseSecurity1: 'SSO とエンタープライズセキュリティコントロール',
            enterpriseSecurity2: 'ユーザーとワークスペースのロールベース権限',
            enterpriseSecurity3: 'ファイルアップロードコントロール',
            enterpriseSecurity4: 'プライベートシークレットモード',
            // Enterprise - Service & Success
            enterpriseService1: '専任カスタマーサポート',
            enterpriseService2: '99.9% SLA とプロアクティブモニタリング',
            enterprise1: '個人メンバーのクォータ管理',
            enterprise2: 'チーム向け無制限共有Vault',
            security1: '内部インテリジェンス共有',
            security2: 'プライベートシークレットモード',
            security3: '統合チーム権限管理',
            security4: '専任カスタマーサポート',
            api1: '300 以上のデータ API と 60 以上の AI エージェント API、特許、ライフサイエンス、R&D、市場インテリジェンスに対応',
            api2: 'チャート、インサイト、AI ワークフローを製品に埋め込み、再構築不要',
            api3: 'Claude Desktop や Cursor を含む MCP 互換クライアントで信頼できる PatSnap ツールに接続',
            api4: 'LangChain、OpenClaw、CrewAI などのフレームワークでワークフローを構築・オーケストレーション',
            api5: 'シナリオデモの探索、API テスト、ウィジェット構築、コード生成を一箇所で',
        },
        // アップグレード確認ダイアログ
        upgradeConfirm: {
            title: 'アップグレード',
            titleWithTier: '{tier} にアップグレード',
            subtitle: 'アップグレードは即座に有効になります。',
            currentPlan: '現在のプラン',
            targetPlan: '対象プラン',
            dueToday: '本日のお支払い',
            creditsGrantedToday: '本日付与されるクレジット',
            creditsValidUntil: 'クレジット有効期限',
            nextRenewal: '次回更新',
            creditsRetainedNotice: '既存のクレジットは保持され、新しいクレジットと併用できます。',
            loadFailed: 'アップグレード詳細の読み込みに失敗しました。',
            retry: '再試行',
            cancel: 'キャンセル',
            processing: '処理中...',
            upgradeNow: '今すぐアップグレード',
            credits: '+{amount} クレジット',
            upgradeSuccess: 'ご登録ありがとうございます！ 早期利用特典として、5倍クレジットがアカウントに付与されました。ぜひご確認ください。',
        },
        // ダウングレード確認ダイアログ
        downgradeConfirm: {
            title: 'ダウングレードを予約',
            titleWithTier: '{tier} へのダウングレードを予約',
            subtitle: '{tier} プランは {date} まで有効です。',
            currentPlan: '現在のプラン',
            scheduledPlan: '現在の降级方案',
            newDowngradePlan: '新降级方案',
            effectiveDate: '有効日',
            currentCredits: '現在のクレジット',
            creditsKept: '元の有効期限まで保持',
            creditsExpire: '期間終了時に失効',
            creditsNextCycle: '次サイクルのクレジット',
            nextRenewal: '次回更新',
            renewalAmount: '{date} に US$ {amount}',
            cancelNotice: '{date} までにこの予約ダウングレードをキャンセルできます。',
            loadFailed: 'ダウングレード詳細の読み込みに失敗しました。',
            retry: '再試行',
            keepCurrentPlan: '現在のプランを維持',
            keepTier: '{tier} を維持',
            processing: '処理中...',
            scheduleDowngrade: 'ダウングレードを予約',
            credits: '{amount} クレジット',
            successMessage: 'ダウングレード予約成功！{tier} プランは {date} まで有効です。',
        },
        oldProTip: {
            title: 'サブスクリプションを更新できません',
            description: '現在、有効な旧 Pro サブスクリプションをご利用中です。旧カウント制プランと Credits プランを同時に有効にすることはできません。Credits プランに切り替えるには、先に自動更新をキャンセルしてください。現在のサブスクリプション終了後、新しいプランを購読できます。',
            confirm: 'サブスクリプションを確認',
            cancel: '了解しました',
        },
    },
};

export const tw = {
    creditsPricing: {
        title: '選擇最適合您的方案',
        subtitle: '解鎖專業功能，提升您的工作效率',
        headerTexts: {
            pricing_proactive_view: { title: '選擇適合你的方案', subtitle: '升級方案或增加 Credits，解鎖更多能力。' },
            feature_upgrade_required: { title: '升級後即可使用此功能', subtitle: '此功能不包含在目前方案中，請升級後繼續。' },
            credits_limit_upgrade: { title: 'Credits 已用完', subtitle: '增加 Credits 或升級方案後即可繼續使用。' },
        },
        free: '免費',
        currentPlan: '目前方案',
        recommend: '推薦',
        monthly: '月付',
        yearly: '年付',
        month: '月',
        perMonth: '/月',
        save: '省 $',
        upgrade: '升級',
        downgrade: '降級',
        contactSales: '聯繫銷售',
        bookDemo: '預約演示',
        custom: '客製化',
        learnMore: '瞭解更多',
        creditsPerMonth: '{credits} 積分 / 月',
        creditsPerMonthSuffix: '積分 / 月',
        scheduledDowngrade: '預約降級',
        scheduledDowngradeNotice: '預約 {date} 降級到 {tier}',
        fiveXCreditsNotice: {
            title: '早鳥優惠已為您啟用。',
            description: '每個套餐包含標準積分的 {multiplier} 倍，續費時將維持相同費率。如有變更，我們將在下一個計費週期前 7 天通知您。',
        },
        freeCreditsRefresh: '免費積分每月刷新',
        creditsIncluded: '專業版方案包含的積分',
        everythingInBasic: '包含基礎版所有功能，額外：',
        everythingInPro: '包含專業版所有功能，額外：',
        everythingInProPlus: '包含專業版所有功能：',
        securityControl: '安全與管理',
        enterpriseCategories: {
            teamUsage: '團隊使用與管理',
            collaboration: '協作',
            governanceSecurity: '治理與安全',
            serviceSuccess: '服務與成功',
        },
        basic: '基礎版',
        pro: '專業版',
        enterprise: '企業版',
        api: 'API',
        basicDesc: '適合個人用戶和開發者',
        proDesc: '適合高級用戶和開發者',
        enterpriseDesc: '適合高效能團隊',
        apiDesc: '適合自定義基礎設施',
        features: {
            basic1: '存取精選核心智能體',
            basic2: '內建技能和連接器，提供現成的研發工作流和精選資料工具',
            basic3: 'AI 驅動的 Pulse 簡報，追蹤競爭情報',
            pro1: '更深度的智能體工作流，用於研究、驗證和監控',
            pro2: '專業匯出，附帶支撐證據（專利和文獻）',
            pro3: '更多可追蹤的技術主題和競爭信號',
            // Enterprise - Team usage & administration
            enterpriseTeam1: '完全存取所有 Eureka 智能體',
            enterpriseTeam2: '團隊共享積分池與自訂分配',
            enterpriseTeam3: '帳單、使用量和使用者管理控制台',
            // Enterprise - Collaboration
            enterpriseCollab1: '共享工作區和團隊專案',
            enterpriseCollab2: '團隊範圍的情報分發',
            // Enterprise - Governance & Security
            enterpriseSecurity1: 'SSO 和企業安全控制',
            enterpriseSecurity2: '使用者和工作區的角色權限',
            enterpriseSecurity3: '檔案上傳控制',
            enterpriseSecurity4: '隱私無痕模式',
            // Enterprise - Service & Success
            enterpriseService1: '專屬客戶支援',
            enterpriseService2: '99.9% SLA 和主動監控',
            enterprise1: '個人成員配額管理',
            enterprise2: '無限團隊共享知識庫',
            security1: '內部情報共享',
            security2: '隱私無痕模式',
            security3: '統一團隊權限管理',
            security4: '專屬客戶支持',
            api1: '300+ 資料 API 和 60+ AI 智能體 API，涵蓋專利、生命科學、研發和市場情報',
            api2: '將圖表、洞察和 AI 工作流嵌入您的產品，無需重建',
            api3: '透過任何 MCP 相容用戶端連接可信的 PatSnap 工具，包括 Claude Desktop 和 Cursor',
            api4: '使用 LangChain、OpenClaw、CrewAI 等框架建構和編排工作流',
            api5: '在一處探索場景示範、測試 API、建構元件和產生程式碼',
        },
        // 升級確認彈窗
        upgradeConfirm: {
            title: '升級',
            titleWithTier: '升級到 {tier}',
            subtitle: '升級立即生效。',
            currentPlan: '目前方案',
            targetPlan: '目標方案',
            dueToday: '今日應付',
            creditsGrantedToday: '今日獲得積分',
            creditsValidUntil: '積分有效期至',
            nextRenewal: '下次續費',
            creditsRetainedNotice: '您現有的積分將被保留，可與新積分一起使用。',
            loadFailed: '載入升級詳情失敗。',
            retry: '重試',
            cancel: '取消',
            processing: '處理中...',
            upgradeNow: '立即升級',
            credits: '+{amount} 積分',
            upgradeSuccess: '感謝訂閱！ 你的早鳥獎勵已到帳：5 倍積分已發放至你的帳戶，快去查看吧。',
        },
        // 降級確認彈窗
        downgradeConfirm: {
            title: '預約降級',
            titleWithTier: '預約降級到 {tier}',
            subtitle: '您的 {tier} 套餐將保持有效至 {date}。',
            currentPlan: '目前方案',
            scheduledPlan: '現在的降级方案',
            newDowngradePlan: '新的降级方案',
            effectiveDate: '生效日期',
            currentCredits: '目前積分',
            creditsKept: '保留至原到期日',
            creditsExpire: '將在週期結束時過期',
            creditsNextCycle: '下週期積分',
            nextRenewal: '下次續費',
            renewalAmount: '{date} 續費 US$ {amount}',
            cancelNotice: '您可以在 {date} 之前取消此預約降級。',
            loadFailed: '載入降級詳情失敗。',
            retry: '重試',
            keepCurrentPlan: '保持目前方案',
            keepTier: '保持 {tier}',
            processing: '處理中...',
            scheduleDowngrade: '預約降級',
            credits: '{amount} 積分',
            successMessage: '降级预约成功！您的 {tier} 套餐将保持有效至 {date}。',
        },
        oldProTip: {
            title: '暫時無法更新訂閱',
            description: '你目前仍在舊版 Pro 訂閱週期內。舊版計次套餐與 Credits 積分套餐無法同時生效。如需切換至 Credits 積分套餐，請先取消續訂；目前訂閱結束後，你可以重新訂閱新套餐。',
            confirm: '查看訂閱',
            cancel: '我知道了',
        },
    },
};
